import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Company } from '@models/companies/company';
import { Document } from '@models/documents/document';
import { EntityChangeData } from '@models/documents/entity-change-data';
import { CompanyChangeData } from '@models/ui-models/company-change-data';
import { ChangeDictionaryHelper } from '@models/ui-models/change-dictionary-helper.model';
import { CompanyForm361Component } from '../../asic-forms/company';
import { formatDate } from "@angular/common";

export class CompanyForm361 extends EntityChangeData {
  static override readonly $type = 'CompanyForm361';

   override changeName = 'Cease as a Registered Agent';

  constructor(data: Partial<CompanyForm361> = {}) {
    super(data);

    this.description = 'Agent cessation';
  }

  override toDictionary(): { key: string; value: string; }[] {
    const dict = new ChangeDictionaryHelper();

    dict
      .add('Type of Change', this.changeName)
      .add('Date of Change', formatDate(this.changeDate, 'dd/MM/yyyy', 'en-US'));

    return dict.dictionary;
  }

  override fillModal(modalRef: NgbModalRef, document: Document, actualCompany: Company): NgbModalRef {
    modalRef = this.fillModalWithCompany(modalRef, actualCompany, true);
    (modalRef.componentInstance as CompanyForm361Component).companyChangeData.documentId = document.documentId;
    return modalRef;
  }

  override fillModalWithCompany(modalRef: NgbModalRef, company: Company, isEdit: boolean): NgbModalRef {
    const instance = modalRef.componentInstance as CompanyForm361Component;

    instance.isEdit = isEdit;
    instance.companyChangeData = new CompanyChangeData(company);
    instance.formModel = structuredClone(this);

    return modalRef;
  }
}
